var render = function render(){var _vm=this,_c=_vm._self._c;return _c('unauthorized-layout',{scopedSlots:_vm._u([{key:"main-content",fn:function(){return [_c('div',{staticClass:"w-full flex flex-col justify-center items-center"},[_c('img',{staticClass:"mb-6",attrs:{"src":require("@/static/logos/rmg.svg"),"alt":"RMG","width":"200"}}),_c('login-form')],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }